import { Sparkles } from 'lucide-react';

import { useTranslation } from '@splitfiesta/i18n';
import { Card } from '@splitfiesta/ui';

export interface ScanUsageSectionProps {
  used: number;
  allowance: number;
}

export function ScanUsageSection({ used, allowance }: ScanUsageSectionProps) {
  const { t } = useTranslation();

  return (
    <Card data-testid="settings-scan-usage">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 flex items-center">
        <Sparkles
          aria-hidden="true"
          className="w-5 h-5 mr-2 text-ai-accent dark:text-ai-accent-dark"
        />
        {t('settings:scans.title')}
      </h3>
      <div className="space-y-1">
        <p
          className="flex flex-wrap gap-x-3 text-sm"
          data-testid="settings-scan-usage-row"
        >
          <span className="min-w-[45%] flex-1 font-medium text-gray-900 dark:text-gray-100">
            {t('settings:scans.thisMonth')}
          </span>
          <span className="ml-auto text-gray-500 dark:text-gray-400">
            {t('settings:scans.used', { used, allowance })}
          </span>
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {t('settings:scans.proGroupsHint')}
        </p>
      </div>
    </Card>
  );
}
